var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "samc-modal",
    { attrs: { width: "450px" } },
    [
      _c("samc-modal-header", [_vm._v("Custom Field Name")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col gap-4 py-2" },
        [
          _c(
            "samc-field",
            { attrs: { "error-message": _setup.validationError } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.model.displayName,
                    expression: "model.displayName",
                  },
                ],
                attrs: { type: "text" },
                domProps: { value: _setup.model.displayName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_setup.model, "displayName", $event.target.value)
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "samc-modal-actions",
        [
          _c(
            "samc-button",
            {
              attrs: { type: "secondary" },
              on: {
                click: function ($event) {
                  return _setup.emits("close")
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _vm._v(" "),
          _c(
            "samc-button",
            {
              attrs: { disabled: !!_setup.validationError },
              on: {
                click: function ($event) {
                  return _setup.handleUpdate()
                },
              },
            },
            [_vm._v("Update Field")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }